import { Component, OnInit, ViewChild, Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';


@Pipe({ name: 'remplaceCharacter' })
export class RemplaceCharacter implements PipeTransform {
  transform(value: string, oldCharacter: string, newCharacter: string): string {
    
    if (value !== null && value !== undefined) {
      let values = value.toString().split(oldCharacter)
      let textReplaced = "";
      let count: number = 0;
      values.forEach(o => {
        if(count == 0){
          textReplaced = o;
        }else if(count > 0){
          textReplaced = textReplaced + newCharacter + o; 
        }
        count++;
      });
      return textReplaced;
    }
  }
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/forms/replaceCharacter.pipe.ts